import React from "react";
class TextEditor extends React.Component {



    render() {

        return (
          <section className="rob-textEditor">
              <div className="container">
                  <div  dangerouslySetInnerHTML={{__html: this.props.text}}  >
                  </div>
              </div>
          </section>
        )
    }

}

export default TextEditor;




// WEBPACK FOOTER //
// ./src/components/elements/blockLoop/TextEditor.js